import React, { forwardRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import styles from "./pdf.module.css";
import SIPReport from "./SIPReport"
import InflationReport from "./InflationReport"
import SWPReport from "./SWPReport"

const PdfLayout = forwardRef((props, ref) => {
  const { type, form,resultCard } = props;   
  return (
    <div
      style={{
        position: "absolute",
        left: "-9999px",
        top: 0,
        visibility: "visible",
        width: "1200px",
      }}
    >
    <div
      ref={ref}
      className={styles.pdf_page}
    >
      <div>&nbsp;</div>
      <Header />

      <div style={{
        flex: 1,
        margin: "0px auto",
      }}>

         {type === "sip" && <SIPReport form={form} resultCard={resultCard} />}
         {type === "inflation" && <InflationReport form={form} resultCard={resultCard} />}
         {type === "swp" && <SWPReport form={form} resultCard={resultCard} />}
           
      </div>

      {type === "swp" ?
        ( 
            <div style={{marginBottom:'2px'}}>
             <Footer pageNumber={type === "swp"?0:1} totalPages={type === "swp"?0:1} />
             </div>
        ):

        (
          <Footer pageNumber={type === "swp"?0:1} totalPages={type === "swp"?0:1} />
        )
      }
        

      
    </div>
    </div>
  );
});

export default PdfLayout;